/** Who last saved a draft in the app, as the session bus reported it
 *  (``session.draft_edited``: name, sha256, user_id).
 *
 *  The event itself only makes the open editor refetch the draft; when
 *  that newer version meets unsaved text, the editor looks here to say
 *  whose save it was: the reader's own in another tab, or someone
 *  else's. Ephemeral, per tab, like typing presence. */

export type DraftEditedEvent = { sha256: string; userId: string | null; at: number };

const edits = new Map<string, DraftEditedEvent>();

function key(sessionId: string, name: string): string {
  return `${sessionId}\u0000${name}`;
}

export function recordDraftEdited(
  sessionId: string,
  name: string,
  event: { sha256: string; userId: string | null },
): void {
  edits.set(key(sessionId, name), { ...event, at: Date.now() });
}

export function lastDraftEdit(sessionId: string, name: string): DraftEditedEvent | null {
  return edits.get(key(sessionId, name)) ?? null;
}
